<template>
  <g class="falla-strut-1500">
  <g class="stag-crosses">
    <polygon class="cross" points="433.81 2547.36 1525.00 2117.36 1550.09 2166.28 458.90 2596.28" fill="#3f7fbb"/>
    <polygon class="cross" points="458.90 1501.84 1550.09 3191.84 1525.00 3211.80 433.81 1521.80" fill="#3f7fbb"/>
  </g>
  <g class="stag-bar-lower">
    <polygon class="topside" points="385.73 2536.82 1598.17 3236.82 1611.16 3229.32 398.72 2529.32" fill="#dde2e5"/>
    <polygon class="frontside" points="385.73 2606.82 1598.17 3306.82 1598.17 3236.82 385.73 2536.82" fill="#c3cace"/>
    <polygon class="main-rightside" points="1598.17 3306.82 1611.16 3299.32 1611.16 3229.32 1598.17 3236.82" fill="#b8bfc4"/>
  </g>
  <g class="stag-bar-upper">
    <polygon class="topside" points="385.73 1406.82 1598.17 2106.82 1611.16 2099.32 398.72 1399.32" fill="#dde2e5"/>
    <polygon class="frontside" points="385.73 1476.82 1598.17 2176.82 1598.17 2106.82 385.73 1406.82" fill="#c3cace"/>
    <polygon class="main-rightside" points="1598.17 2176.82 1611.16 2169.32 1611.16 2099.32 1598.17 2106.82" fill="#b8bfc4"/>
  </g>
  </g>
</template>
<script>
export default {
  name: "Strut1500-F.vue",
};
</script>
